export const formatAmount = (amount) => {
  if (typeof amount !== "number") {
    return "₹0";
  }
  return `₹${amount.toLocaleString("en-IN")}`;
};
